var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8983 0.298828C27.1333 0.298828 29.2833 1.18216 30.865 2.76716C32.4483 4.34883 33.3333 6.48216 33.3333 8.7155V21.8822C33.3333 26.5322 29.55 30.2988 24.8983 30.2988H8.43333C3.78167 30.2988 0 26.5322 0 21.8822V8.7155C0 4.0655 3.765 0.298828 8.43333 0.298828H24.8983ZM27.55 11.1988L27.6833 11.0655C28.0817 10.5822 28.0817 9.88216 27.665 9.39883C27.4333 9.1505 27.115 8.99883 26.7833 8.9655C26.4333 8.94716 26.1 9.0655 25.8483 9.29883L18.3333 15.2988C17.3667 16.1005 15.9817 16.1005 15 15.2988L7.5 9.29883C6.98167 8.91549 6.265 8.9655 5.83333 9.41549C5.38333 9.86549 5.33333 10.5822 5.715 11.0822L5.93333 11.2988L13.5167 17.2155C14.45 17.9488 15.5817 18.3488 16.7667 18.3488C17.9483 18.3488 19.1 17.9488 20.0317 17.2155L27.55 11.1988Z",
    fill: "#F58320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage1);
export default __webpack_public_path__ + "static/media/Message1.e853f67664adfc47182a3fccf6314b75.svg";
export { ForwardRef as ReactComponent };